export default "__VITE_ASSET__B6esmIY7__"